import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from '../shared/Modal';


const ExceptionsForm = () => {
    const [dates, setDates] = useState({
        priceMatchRequest: null,
        priceMatchDecision: null,
        exceptionRequest: null,
        exceptionRequestSummary: null,
        requestTypeClear: null,
        creditRiskDecision: null,
        secondaryDecision: null,
        secondaryConditionReceived: null,
        priceExceptionAdded: null,
        creditRiskConditionReceived: null
    });

    const [loading, setLoading] = useState(true);
    const [showToast, setShowToast] = useState(false);
    const [showErrorToast, setShowErrorToast] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorTitle, setErrorTitle] = useState("Submission Error");


    const [priceMatchNote, setPriceMatchNote] = useState("");
    const [priceMatchDecision, setPriceMatchDecision] = useState("");
    const [exceptionRequestSummary, setExceptionRequestSummary] = useState("");
    const [requestType, setRequestType] = useState("");
    const [requestTypeOther, setRequestTypeOther] = useState("");
    const [compensatingFactor, setCompensatingFactor] = useState("");
    const [guidelineVersion, setGuidelineVersion] = useState("");
    const [creditRiskNotes, setCreditRiskNotes] = useState("");
    const [creditRiskDecision, setCreditRiskDecision] = useState("");
    const [secondaryNotes, setSecondaryNotes] = useState("");
    const [secondaryDecision, setSecondaryDecision] = useState("");


    useEffect(() => {
        setLoading(false);
    }, []);

    const handleDateChange = (field, date) => {
        setDates(prev => ({
            ...prev,
            [field]: date
        }));
    };
    const handleSubmit = async () => {
    }


    return (
        <>
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-400 block-ui-overlay block-ui-container">
                    <div className="block-ui-message-container">
                        <div className="block-ui-message">Loading...</div>
                    </div>
                </div>
            )}

            {showToast && (
                <div className="fixed top-6 right-6 z-50 flex items-start gap-3 bg-green-100 border-l-4 border-green-600 text-green-800 p-4 rounded-md shadow-lg max-w-sm animate-fade-in">
                    <div className="text-2xl">✅</div>
                    <div className="flex-1">
                        <div className="font-semibold mb-1">Success</div>
                        <div className="text-sm leading-relaxed break-words">Form saved successfully</div>
                    </div>
                </div>

            )}
            <Modal
                title={errorTitle}
                message={errorMessage}
                isOpen={showErrorToast}
                onClose={() => setShowErrorToast(false)}
                type="error"
            />
            <div className="space-y-10 p-25px">
                <div className="bg-[var(--white)] rounded-lg p-3 space-y-6 max-w-8xl mx-auto">
                    <h2 className="page-title">Exceptions</h2>
                    <div className="text-right mt-4">
                        <button
                            onClick={() => handleSubmit(false)}
                            className="btn-custom rounded text-[#FFFFFF] bg-[#2080C3] hover:text-[#E6EEF8] hover:bg-[#5DA5D9]  
 active:bg-white transition-colors duration-200"
                        >
                            Save
                        </button>

                    </div>
                </div>

                <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9]">
                    <div className="section-header">Price Match Exception</div>
                    <div className="px-4 py-4">
                        <div className="border rounded-md p-4 mb-3">
                            <div className="grid grid-cols-2 gap-4 mb-2">
                                <div>
                                    <label className="form-label mb-1">Price Match Request Date <span className="text-red-500">*</span></label>
                                    <DatePicker
                                        className="form-input mb-1"
                                        selected={dates.priceMatchRequest}
                                        onChange={(date) => handleDateChange('priceMatchRequest', date)}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="MM/DD/YYYY"
                                        isClearable
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="form-label">Price Match Note <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={priceMatchNote}
                                        onChange={(e) => setPriceMatchNote(e.target.value)}
                                        className="form-input"
                                        placeholder="Enter notes"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="grid md:grid-cols-2 gap-4">
                                {/* Left Column - Select */}
                                <div>
                                    <label className="form-label mb-1">Price Match Decision <span className="text-red-500">*</span></label>
                                    <select
                                        value={priceMatchDecision}
                                        onChange={(e) => setPriceMatchDecision(e.target.value)}
                                        className="form-input  w-full text-sm border rounded p-1"
                                        required
                                    >
                                        <option>No Selection</option>
                                    </select>
                                </div>

                                {/* Right Column - Date Pickers */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="form-label">Price Match Decision Date <span className="text-red-500">*</span></label>
                                        <DatePicker
                                            selected={dates.priceMatchDecision}
                                            onChange={(date) => handleDateChange('priceMatchDecision', date)}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="MM/DD/YYYY"
                                            className="form-input w-full mt-1"
                                            isClearable
                                            minDate={dates.priceMatchRequest}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="form-label">Price Exception Added Date <span className="text-red-500">*</span></label>
                                        <DatePicker
                                            selected={dates.priceExceptionAdded}
                                            onChange={(date) => handleDateChange('priceExceptionAdded', date)}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="MM/DD/YYYY"
                                            className="form-input w-full mt-1"
                                            isClearable
                                            minDate={dates.priceMatchRequest}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9]">
                    <div className="section-header">Pre-Submission Exception</div>
                    <div className="px-4 py-4">
                        <div className="border rounded-md p-4 mb-3">
                            <div className="grid md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="form-label">Exception Request Date<span className="text-red-500">*</span></label>
                                    <DatePicker
                                        selected={dates.exceptionRequest}
                                        onChange={(date) => handleDateChange('exceptionRequest', date)}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="MM/DD/YYYY"
                                        className="form-input"
                                        isClearable
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="form-label">Exception Request Summary<span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={exceptionRequestSummary}
                                        onChange={(e) => setExceptionRequestSummary(e.target.value)}
                                        className="form-input"
                                        placeholder="Enter exception summary"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="grid md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="form-label mb-1">Request Type <span className="text-red-500">*</span></label>
                                    <select
                                        value={requestType}
                                        onChange={(e) => setRequestType(e.target.value)}
                                        className="form-input  w-full text-sm border rounded p-1"
                                        required
                                    >
                                        <option>No Selection</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="form-label">Request Type: Other</label>
                                    <input
                                        type="text"
                                        value={requestTypeOther}
                                        onChange={(e) => setRequestTypeOther(e.target.value)}
                                        className="form-input"
                                        placeholder=""
                                    />
                                </div>
                            </div>

                            <div className="grid md:grid-cols-2 gap-4 mb-6">
                                <div>
                                    <label className="form-label">Compensating Factor</label>
                                    <input
                                        type="text"
                                        value={compensatingFactor}
                                        onChange={(e) => setCompensatingFactor(e.target.value)}
                                        className="form-input"
                                        placeholder=""
                                    />
                                </div>

                                <div>
                                    <label className="form-label mb-1">Guideline Version<span className="text-red-500">*</span></label>
                                    <select
                                        value={guidelineVersion}
                                        onChange={(e) => setGuidelineVersion(e.target.value)}
                                        className="form-input  w-full text-sm border rounded p-1"
                                        required
                                    >
                                        <option>No Selection</option>
                                    </select>
                                </div>
                            </div>

                            {/* Credit Risk Section */}
                            <div className="border-t pt-4 mb-6">
                                <h3 className="text-sm font-semibold text-gray-700 mb-3">Credit Risk</h3>

                                <div className="grid md:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label className="form-label">Credit Risk Notes</label>
                                        <input
                                            type="text"
                                            value={creditRiskNotes}
                                            onChange={(e) => setCreditRiskNotes(e.target.value)}
                                            className="form-input"
                                            placeholder="Credit notes"
                                        />
                                    </div>

                                    <div>
                                        <label className="form-label mb-1">Credit Risk Decision <span className="text-red-500">*</span></label>
                                        <select
                                            value={creditRiskDecision}
                                            onChange={(e) => setCreditRiskDecision(e.target.value)}
                                            className="form-input  w-full text-sm border rounded p-1"
                                            required
                                        >
                                            <option>No Selection</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="form-label">Credit Risk Decision Date <span className="text-red-500">*</span></label>
                                        <DatePicker
                                            selected={dates.creditRiskDecision}
                                            onChange={(date) => handleDateChange('creditRiskDecision', date)}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="MM/DD/YYYY"
                                            className="form-input"
                                            isClearable
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="form-label">Credit Risk Condition Received <span className="text-red-500">*</span></label>
                                        <DatePicker
                                            selected={dates.creditRiskConditionReceived}
                                            onChange={(date) => handleDateChange('creditRiskConditionReceived', date)}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="MM/DD/YYYY"
                                            className="form-input"
                                            isClearable
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default ExceptionsForm;	